import ApiService from "./ApiService";

export default class CountyService extends ApiService
{
    collection = 'counties'
}